// extracted by mini-css-extract-plugin
export default {"tech":"HW14_tech__4KLlA","loading":"HW14_loading__OedCv","input":"HW14_input__WJd1H","hw":"HW14_hw__Stcna","inputSpan":"HW14_inputSpan__P6Pyw"};